<template>
  <router-view/>
</template>

<script>
import { useRoute } from 'vue-router';
import { watch } from 'vue';

export default {
  name: 'App',
  mounted() {
    this.setBodyClass();
  },
  methods: {
    setBodyClass() {
      // Set the initial class based on the current route name
      document.body.className = this.$route.name;
    },
  },
  setup() {
    const route = useRoute();
    watch(
      () => route.name,
      async (newId) => {
        document.body.className = '';
        document.body.classList.add(`route-${newId}`);
      },
    );
  },
};
</script>

<style lang="scss">
@import './assets/mixins.scss';

@font-face {
    font-family: 'SangBleuSunrise';
    src: url('assets/fonts/SangBleuSunrise-Regular-WebS.woff2') format('woff2'),
         url('assets/fonts/SangBleuSunrise-Regular-WebS.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    unicode-range: U;
}

@font-face {
    font-family: 'SangBleuKingdom';
    src: url('assets/fonts/SangBleuKingdom-Medium-WebS.woff2') format('woff2'),
         url('assets/fonts/SangBleuKingdom-Medium-WebS.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    unicode-range: U;
}

body {
    font-family: 'SangBleuSunrise', Arial, sans-serif;
    font-size: 14px;
    font-weight: normal;
    padding: 0;
    margin: 0;

    &.route-menu {
      background-color: #352d89;
    }
}

h1, h2, h3, h4, h5 {
    font-family: 'SangBleuKingdom', Arial, sans-serif;
    font-weight: normal;
    margin: 0;
}

h1 {
  @include text-header;
  small {
    display: block;
    margin-top: -2px;
    @include text-paragraph;
  }
}

h2 {
  @include text-header;
}

h3 {
  @include text-header;
  line-height: 1.2em;
}

hr {
  border-top: 1px solid #352d89;
  border-bottom: none;
  margin: 0 0 11px;
}

.button {
  background-color: #352d89;
  padding: 1em;
  border-radius: 2em;
  text-decoration: none;
  color: #fff;
  text-transform: uppercase;
  width: 165px;
  display: block;
  margin: 0 auto 1.75em;
  box-sizing: border-box;

  @include text-button;

  &--white {
    background-color: #fff;
    color: #352d89;
  }

  &--disabled {
    pointer-events: none;
  }
}
</style>
